import React, { useState, ReactNode } from 'react';
import { Loader } from './Loader';

interface LoaderProviderProps {
    children: ReactNode;
}

interface LoaderProviderComponent extends React.FC<LoaderProviderProps> {
    init: () => void;
    show: () => void;
    hide: () => void;
}

let setIsVisibleFunc: (value: boolean) => void;

export const LoaderProvider: LoaderProviderComponent = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);

    setIsVisibleFunc = (value: boolean) => {
        setIsVisible(value);
    };

    return (
        <>
            {children}
            <Loader isOpen={isVisible} />
        </>
    );
};

LoaderProvider.init = () => {
    const loaderApp = document.getElementById('loader-app');
    if (loaderApp && loaderApp.style) {
        loaderApp.style.display = 'none';
    }
};

LoaderProvider.show = () => {
    LoaderService.show();
};

LoaderProvider.hide = () => {
    LoaderService.hide();
};

export class LoaderService {
    private static isVisible = false;
    private static previousIsVisible = false;
    private static hideTimeoutId: NodeJS.Timeout | null = null;
    private static animationDuration = 300; // ms

    static show = () => {
        // Clear any pending hide animation
        if (LoaderService.hideTimeoutId) {
            clearTimeout(LoaderService.hideTimeoutId);
            LoaderService.hideTimeoutId = null;
        }

        LoaderService.isVisible = true;
        LoaderService.update();
    };

    static hide = () => {
        LoaderService.isVisible = false;
        LoaderService.hideTimeoutId = setTimeout(() => {
            LoaderService.update();
            LoaderService.hideTimeoutId = null;
        }, LoaderService.animationDuration);
    };

    private static update = () => {
        if (LoaderService.isVisible === LoaderService.previousIsVisible) return;

        LoaderService.previousIsVisible = LoaderService.isVisible;
        if (setIsVisibleFunc) {
            setIsVisibleFunc(LoaderService.isVisible);
        }
    };
}
